"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JourneyConditionComparisonEnum = void 0;
var JourneyConditionComparisonEnum;
(function (JourneyConditionComparisonEnum) {
    JourneyConditionComparisonEnum["Changed"] = "changed";
    JourneyConditionComparisonEnum["nEqNum"] = "not_equal_num";
    JourneyConditionComparisonEnum["nEqStr"] = "not_equal_str";
    JourneyConditionComparisonEnum["nEqPhoneNumber"] = "not_equal_phone_number";
    JourneyConditionComparisonEnum["EqNum"] = "equal_num";
    JourneyConditionComparisonEnum["EqStr"] = "equal_str";
    JourneyConditionComparisonEnum["EqPhoneNumber"] = "equal_phone_number";
    JourneyConditionComparisonEnum["strictEq"] = "strict_eq";
    JourneyConditionComparisonEnum["strictNotEq"] = "not_strict_eq";
    JourneyConditionComparisonEnum["Gt"] = "gt";
    JourneyConditionComparisonEnum["GtDateTime"] = "gt_datetime";
    JourneyConditionComparisonEnum["Gte"] = "gte";
    JourneyConditionComparisonEnum["Lt"] = "lt";
    JourneyConditionComparisonEnum["LtDateTime"] = "lt_datetime";
    JourneyConditionComparisonEnum["Lte"] = "lte";
    JourneyConditionComparisonEnum["IsNotNull"] = "is_not_null";
    JourneyConditionComparisonEnum["IsNull"] = "is_null";
    JourneyConditionComparisonEnum["IsFalsy"] = "is_falsy";
    JourneyConditionComparisonEnum["IsFalse"] = "is_false";
    JourneyConditionComparisonEnum["IsTruly"] = "is_truly";
    JourneyConditionComparisonEnum["IsTrue"] = "is_true";
    JourneyConditionComparisonEnum["IsEmpty"] = "is_empty";
    JourneyConditionComparisonEnum["IsNotEmpty"] = "is_not_empty";
    JourneyConditionComparisonEnum["IsUndefined"] = "is_undefined";
    JourneyConditionComparisonEnum["IsDefined"] = "is_defined";
    JourneyConditionComparisonEnum["IncludesNum"] = "includes_num";
    JourneyConditionComparisonEnum["Includes"] = "includes";
    JourneyConditionComparisonEnum["IncludesPhoneNumber"] = "includes_phone_number";
    JourneyConditionComparisonEnum["NotIncludesNum"] = "not_includes_num";
    JourneyConditionComparisonEnum["NotIncludes"] = "not_includes";
    JourneyConditionComparisonEnum["NotIncludesPhoneNumber"] = "not_includes_phone_number";
    JourneyConditionComparisonEnum["IncludesStr"] = "includes_str";
    JourneyConditionComparisonEnum["NotIncludesStr"] = "not_includes_str";
    JourneyConditionComparisonEnum["Contains"] = "contains";
    JourneyConditionComparisonEnum["NotContains"] = "not_contains";
    JourneyConditionComparisonEnum["StartsWith"] = "starts_with";
    JourneyConditionComparisonEnum["NotStartsWith"] = "not_starts_with";
    JourneyConditionComparisonEnum["EndsWith"] = "ends_with";
    JourneyConditionComparisonEnum["NotEndsWith"] = "not_ends_with";
    JourneyConditionComparisonEnum["AnyOfStr"] = "any_of_str";
    JourneyConditionComparisonEnum["NoneOfStr"] = "none_of_str";
    JourneyConditionComparisonEnum["AnyOfNum"] = "any_of_num";
    JourneyConditionComparisonEnum["NoneOfNum"] = "none_of_num";
    JourneyConditionComparisonEnum["ArrayLength"] = "array_length";
})(JourneyConditionComparisonEnum = exports.JourneyConditionComparisonEnum || (exports.JourneyConditionComparisonEnum = {}));
